import { render, staticRenderFns } from "./SmartCaptcha.vue?vue&type=template&id=595197ba&scoped=true"
import script from "./SmartCaptcha.vue?vue&type=script&lang=js"
export * from "./SmartCaptcha.vue?vue&type=script&lang=js"
import style0 from "./SmartCaptcha.vue?vue&type=style&index=0&id=595197ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595197ba",
  null
  
)

export default component.exports